export default class SweetAlert {

    constructor($rootScope) {
        this._rootScope = $rootScope;
    }

    swal( arg1, arg2, arg3 ) {
        this._rootScope.$evalAsync(() => {
            if( typeof(arg2) === 'function' ) {
                swal( arg1, (isConfirm) => {
                    this._rootScope.$evalAsync( () =>{
                        arg2(isConfirm);
                    });
                }, arg3 );
            } else {
                swal( arg1, arg2, arg3 );
            }
        });
    }
    success(title, message) {
        this._rootScope.$evalAsync(() => {
            swal( title, message, 'success' );
        });
    }
    error(title, message) {
        this._rootScope.$evalAsync(() => {
            swal( title, message, 'error' );
        });
    }
    warning(title, message) {
        this._rootScope.$evalAsync(() => {
            swal( title, message, 'warning' );
        });
    }
    info(title, message) {
        this._rootScope.$evalAsync(() => {
            swal( title, message, 'info' );
        });
    }
    showInputError(message) {
        this._rootScope.$evalAsync(() => {
            swal.showInputError( message );
        });
    }
    close() {
        this._rootScope.$evalAsync(() => {
            swal.close();
        });
    }
};

SweetAlert.$inject = ['$rootScope'];
